import Vue from 'vue'
import MyAuthorizationMaskIndexes from '@/plugins/my-authorization-mask-indexes'
Vue.mixin({
    methods: {
        maskValue (section, operation) {
            return MyAuthorizationMaskIndexes.CRUD(section, operation)
        }
    }
})
